/* DeleteButton.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./DeleteButton.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import Button from '@atlaskit/button/standard-button';
import CrossCircleIcon from '@atlaskit/icon/utility/migration/cross-circle';
import { N500 } from '@atlaskit/theme/colors';
import { deleteEmojiLabel } from '../../util/constants';
import { emojiDeleteButton } from './styles';
import { Box } from '@atlaskit/primitives/compiled';
var styles = {
  boxWrapperStyle: "_1bsbf6fq _4t3if6fq"
};
var deleteButton = null;

/**
 * Test id for wrapper Emoji delete button
 */
export var RENDER_EMOJI_DELETE_BUTTON_TESTID = 'render-emoji-delete-button';
var DeleteButton = function DeleteButton(props) {
  return /*#__PURE__*/React.createElement("span", {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    className: ax(["_3um015vq _1e0c1txw _kqswstnw _154ix0bf _1xi2x0bf _1pbykb7n _13t3idpf", emojiDeleteButton]),
    "data-testid": RENDER_EMOJI_DELETE_BUTTON_TESTID
  }, /*#__PURE__*/React.createElement(Button, {
    iconBefore: /*#__PURE__*/React.createElement(Box, {
      xcss: styles.boxWrapperStyle
    }, /*#__PURE__*/React.createElement(CrossCircleIcon, {
      label: deleteEmojiLabel,
      color: "var(--ds-text-subtle, ".concat(N500, ")"),
      LEGACY_size: "small"
    })),
    onClick: props.onClick
    // TODO: (from codemod) "link" and "subtle-link" appearances are only available in LinkButton, please either provide a href prop then migrate to LinkButton, or remove the appearance from the default button.
    ,
    appearance: "subtle-link",
    spacing: "none",
    testId: "emoji-delete-button",
    tabIndex: -1
  }));
};
export default DeleteButton;